"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CellShiftsColumn = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const constants_1 = require("../../../../constants");
const elements_1 = require("../../../../elements");
exports.CellShiftsColumn = (0, styled_1.default)(elements_1.Flex)({
    height: '100%',
    position: 'relative',
    alignItems: 'flex-start',
    gap: constants_1.theme.spacing[1.5],
    flexDirection: 'column',
});
